module.exports = __webpack_public_path__ + "static/media/under-dog-mobile.7b14af7c.png";